import { Component, OnInit, ViewContainerRef, TemplateRef, ViewChild } from '@angular/core';
import { DemoService } from './../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Router } from '@angular/router';
import { MysqlService } from './../../services/mysql.service';

import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { Observable } from 'rxjs';

import { Subscription } from 'rxjs';


import { FileUploaderService } from './../..//services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, DataUtil } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';
import { IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { GlobalFunctionsService } from './../../services/global-functions.service';

import { SystemFile } from './../../shared/models/file.model';
import { SystemLog } from './../../shared/models/sysLog.model';
import { Permission } from './../../shared/models/permission.model';
import { Brand } from './../../shared/models/brand.model';
import { BrandType } from './../../shared/models/brandType.model';

@Component({
  selector: 'app-agent-job-view',
  templateUrl: './agent-job-view.component.html',
  styleUrls: ['./agent-job-view.component.css']
})
export class AgentJobViewComponent implements OnInit {
  client_contact: Object;
  assignedList: Object;
  job_type: Object;
  client: Object;
  clientInvoice: Object;
  clientContact: Object;
  report_brand_brand: Object;
  invoice_brand_brand: Object;
  report_brand_user: Object;
  job_subject_type: Object;
  job_plaintiff_type: Object;
  job_type_location: Object;
  job_type_court: Object;
  job_type_document: Object;
  job_type_affidavit: Object;
  nav: any;
  job_id: number;
  job: any;
  allAgents: any;
  assignedAgentsList: Object;
  agent_associated: number;
  current_subject_status: any;

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router, 
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService) {


      this.nav = document.querySelector('nav.navbar');
    
      this.job_id = +this.route.snapshot.paramMap.get('job_id');

     }

  ngOnInit() {
    this.getJob(this.job_id); // used to hide the job if still pending
  }



  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
      data => {
        this.job = data;
        let res = data[0];
        this.getJobType(res.job_type_id);
        this.getClientMapping(res.client_id);
        this.getClientInvoice(res.client_invoice_id);
        this.getClientContactSharmans(res.client_contact_id);
        this.getJobSubjectType(res.job_subject_type_id);
        this.getJobPlaintiffType(res.job_plaintiff_type_id);
        this.getJobTypeLocation(res.job_type_location_id);
        this.getJobTypeCourt(res.job_type_court_id);
        this.getJobTypeDocument(res.job_type_document_type_id);
        this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
        this.getJobAgentAssigned(res.job_id);
        this.getReportBrand(res.brand_report_id); // get company brand
        this.getInvoiceBrand(res.brand_invoice_id); // get company invoice brand
        this.getReportBrandUser(res.brand_report_user_id); // get report brand user

        this.current_subject_status = res.job_status_code;
        // Block agents from being able to submit or edit anytypes of subect details... focus on attendances and notes.
        if (this.gfunc.sessionUserLevel == 5){
          this.getSubjectBrandAgentsAssignedAll();
          }




      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getClientContactSharmans(id) {
    this._demoService.getClientContactSharmans(id).subscribe(
      data => { this.client_contact = data; },
      err => console.error(err),
      // () => console.log('done loading candidate for update')
    );
  }

  
  getJobAgentAssigned(job_id) {
    this._demoService.getJobAgentsAssigned(job_id).subscribe(
      data => {
        this.assignedList = data;
      },
      err => console.error(err),
      // () => console.log('Loaded Assigned Agents Loaded.')
    );
  }

  getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
      data => {
        this.job_type = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  // Get the name of job type from the ID
  getClientMapping(client_id) {
    this._demoService.getClientMappingID(client_id).subscribe(
      data => {
        this.client = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  // Get the name of job type from the ID
  getClientInvoice(client_id) {
    this._demoService.getClientMappingID(client_id).subscribe(
      data => {
        this.clientInvoice = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  // Get the name of job type from the ID
  getClientContact(id) {
    this._demoService.getClientContactID(id).subscribe(
      data => {
        this.clientContact = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // GET CLIENT FROM BRANDS client - brand_report_id

  getReportBrand(brand_report_id) {
    this._demoService.getBrandById(brand_report_id).subscribe(
      data => {
        this.report_brand_brand = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getInvoiceBrand(brand_invoice_id) {
    this._demoService.getBrandById(brand_invoice_id).subscribe(
      data => {
        this.invoice_brand_brand = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  // need to get user details
  getReportBrandUser(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
      data => { this.report_brand_user = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJobSubjectType(job_subject_type_id) {
    this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
      data => { this.job_subject_type = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobPlaintiffType(job_plaintiff_type_id) {
    this._demoService.getJobPlaintiffType(job_plaintiff_type_id).subscribe(
      data => { this.job_plaintiff_type = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getJobTypeLocation(job_type_location_id) {
    this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
      data => {
        this.job_type_location = data;
        let res = data[0];
        // this.model.job_type_id = res.job_type_id;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
      data => {
        this.job_type_court = data;
        // let res = data[0];
        // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);


      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJobTypeDocument(job_type_document_type_id) {
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
      data => {
        this.job_type_document = data;
        let res = data[0];
        // this.model.job_type_id = res.job_type_id;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJobTypeAffidavit(job_type_affidavit_type_id) {
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
      data => {
        this.job_type_affidavit = data;
        let res = data[0];
        // this.model.job_type_id = res.job_type_id;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  
       
// need to get all associated agents of the job and push thier information to array
getSubjectBrandAgentsAssignedAll() {
  console.log('Running Subject Agent Access Checker!!! 101');
    this.allAgents = [];
    this._demoService.getSubjectBrandAgentsAssignedAll().subscribe(
       data => { 
         this.assignedAgentsList = data;
        //  let res = data[0];
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           this.agent_associated = 0;
  
           let array = [];
           let ata_array = [];
           let array_length;
  
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
  
           this.allAgents.push({
             recipient_name: res.name + '',
             recipient_email_address: res.email,
             recipient_brand_id: res.brand_id,
             recipient_subject_id: res.subject_id,
             recipient_brand_type_id: res.brand_type_id,
             recipient_user_id: null,
             recipient_user_level_id: null,
             recipient_type_name: 'Agent',
           });
           } // end for loop
        //  this.allAgents = this.allAgents; // ?? this may be causing errors.
         // set records to send to subject_notes data table
        //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
  
              // array = res.assigned_to_agents;

            if (this.allAgents.lenght >= 1) {  } // end if no agents in list?
                  // array = JSON.parse(this.allAgents);
                  array = this.allAgents;
                  // console.log('array: ', array);
                      
                  ata_array = array.filter( (n: any) => (
                          n.recipient_brand_id === this.gfunc.sessionBrandId
                          // n.note_id >= '200'
                          // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
                          ));
                          // console.log('ata_array.lenght: ', ata_array.length);
                        
                        // does the check and decides if to display page or note
                          array_length = ata_array.length;
                          if (array_length >= 1) {
                            this.agent_associated = 1;
                          };
                          // blocks the access
                          if (array_length == 0) {
                          this.agent_associated = 0;
                          }
                          // console.log('Is Agent Associated? 0 | 1 : ', this.agent_associated);
              
      },
       err => console.error(err),
       // () => console.log('Loaded Assigned Agents Loaded.')
     );
   }
  

}
